import Vue from 'vue';
import * as moment from 'moment';
import Segment from '@/Segment';

const CHURN_SURVEY_KEY = 'riseup.churnSurvey';

const state = {
  answers: {},
};

const getters = {};

const actions = {
  setSurveyAnswer({ commit }, { questionName, answer }) {
    commit('setAnswer', { questionName, answer });
  },
  async saveChurnSurveyDetails({ rootState, dispatch }) {
    await dispatch('subscriptionState/fetchSubscriptionState', {}, { root: true });
    const { subscriptionState, since } = rootState.subscriptionState;
    const { customerId } = rootState.session;
    localStorage.setItem(CHURN_SURVEY_KEY, JSON.stringify({
      id: customerId,
      state: subscriptionState,
      onStateSince: since,
    }));
  },
  reportToSegment({ state }, eventName) {
    const churnCustomerDetails = JSON.parse(localStorage.getItem(CHURN_SURVEY_KEY));
    if (churnCustomerDetails && churnCustomerDetails.id) {
      Segment.trackUserInteraction(eventName, {
        customerId: churnCustomerDetails.id,
        subscriptionState: churnCustomerDetails.state,
        timeOnPreviousState: moment.duration(moment().diff(churnCustomerDetails.onStateSince)).humanize(),
        ...state.answers,
      });
    } else {
      Segment.trackUserInteraction('ChurnSurveyHasNoCustomerId');
    }
  },
};

const mutations = {
  setAnswer(state, { questionName, answer }) {
    Vue.set(state.answers, questionName, answer);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
